import {createClient} from "@supabase/supabase-js";
import {Database} from "./supabase-types";

export const supabase = createClient<Database>(
  "https://kuwtlqgiqdrvuvimurmd.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt1d3RscWdpcWRydnV2aW11cm1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTE0MDI5NDgsImV4cCI6MjAwNjk3ODk0OH0.znIl-ak5C-xTsBN9X7H1BdQIFdWGKbXkGC3B8kc4kHY",
  {db: {schema: "airtablepg_production"}}
);
